import { gql } from "@apollo/client";

// Writes the single `wsm.fulfillment` entry. updateMetadata MERGES by key, so
// this cannot disturb the other wsm.* entries on the shop (will_call,
// google_tag_manager and friends) — worth knowing before reaching for a
// read-modify-write of the whole metadata array.
export const UPDATE_FULFILLMENT_SHOP_METADATA = gql`
  mutation UpdateFulfillmentShopMetadata($id: ID!, $input: [MetadataInput!]!) {
    updateMetadata(id: $id, input: $input) {
      errors {
        field
        message
      }
      item {
        metadata {
          key
          value
        }
      }
    }
  }
`;
